<template>
  <div>
    <div class="mb-6 pb-6 border-b-2 border-grey-light flex flex-wrap items-center">
      <div>
        <h1 class="text-grey-darker text-xl font-semibold leading-normal uppercase">
          Event Registration Successful
        </h1>
      </div>
    </div>

    <loader v-if="!loaded" />

    <!-- OFFICE HAS NO ACCESS -->
    <panel v-else-if="!officeAccess" class="pt-6">
      <strong class="mb-2">Access Denied</strong>
      <p>Your office does not have access to use this system.</p>
    </panel>

    <div v-else class="rounded-lg bg-white relative w-full py-8 px-4">
      <div class="max-w-lg mx-auto text-center">
        <h3 class="flex justify-center items-center mb-1 leading-none">Event Registration</h3>
        <icon name="tick_circle" :center="false" class="mx-auto mb-1 w-32 h-32 text-green" />
        <h3 class="text-center mb-4">Thank you for your order</h3>
        <p class="mb-6">Your order has been processed. You will also receive confirmation of your booking by email.</p>
        <hr class="border-b border-grey-light mb-6">
        <h4 class="text-center mb-4">{{ conference.name }} Tickets</h4>
        <h4 class="text-center font-normal mb-4">{{ 'x' + order.registrants.length + ' Attendees' }}</h4>
        <table class="w-full mb-8">
          <tbody>
            <tr v-for="(registrant, i) in order.registrants" :key="i">
              <td class="text-left" :class="i == order.registrants.length - 1 ? 'pb-12' : 'pb-6'">
                <h4 class="mb-1 text-sm">{{ registrant.first_name + ' ' + registrant.last_name }}</h4>
                <p class="mb-1 text-sm">{{ registrant.email }}</p>
                <p class="text-sm">{{ ticketName(registrant.ticket_id) }}</p>
              </td>
              <td class="align-bottom text-right text-sm" :class="i == order.registrants.length - 1 ? 'pb-12' : 'pb-6'">
                {{ '£' + ticketFee(registrant.ticket_id) }}
              </td>
            </tr>
            <tr class="border-t border-grey-light text-right">
              <td colspan="2" class="text-sm pt-6 pb-2">{{ 'VAT £' + order.vat.toFixed(2) }}</td>
            </tr>
            <tr class="border-b border-grey-light text-right">
              <td colspan="2" class="pb-6 text-xl font-bold">{{ '£' + order.total.toFixed(2) }}</td>
            </tr>
            </tbody>
        </table>
        <table class="w-full mb-6">
          <tbody>
            <tr>
              <td class="w-1/2 text-right pr-4">{{ 'Reference: ' + order.location }}</td>
              <td class="w-1/2 text-left pl-4">{{ 'Order No.: ' + order.id }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapActions, mapState } from 'vuex'
export default {
  data () {
    return {
      loaded: false,
      conference: null,
      officeAccess: false,
      sessionId: null,
      order: null,
      tickets: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.sessionId = this.$route.query.session_id
    Promise.all([
      this.fetchConference(),
      this.loadOrder()
    ]).then(() => {
      this.loadTicketOptions()
    }).catch((errors) => {
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-exclamation-triangle',
        title: 'Order Not Found',
        info: errors.response.data.message
      })
    })
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    fetchConference () {
      return api.get('conference', {
        params: {
          network_id: this.selectedOffice.network_id
        }
      }).then((response) => {
        this.conference = response.data.conference
      })
    },
    loadOrder () {
      return api.post('conference/orders/payment-successful', {
        session_id: this.sessionId
      }).then((response) => {
        this.order = response.data
      })
    },
    loadTicketOptions () {
      return api.get('conference/tickets', {
        params: {
          conference_id: this.conference.id,
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.tickets = response.data.tickets
        this.officeAccess = response.data.access
        this.loaded = true
      })
    },
    ticketName (id) {
      let ticket = this.tickets.find(c => c.id === id)
      return ticket.name
    },
    ticketFee (id) {
      let ticket = this.tickets.find(c => c.id === id)
      return ticket.price.toFixed(2)
    }
  }
}
</script>
